<!-- /fees answered 404: no configured price for this selection. Unpriced means
     "not bookable online", never free — show the route to the register office
     instead of a fee table. -->
<div class="govuk-warning-text" *ngIf="feesUnavailable">
  <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
  <strong class="govuk-warning-text__text">
    <span class="govuk-visually-hidden">Warning</span>
    We are unable to calculate the fee for this booking, so it cannot be booked
    online. Please contact the register office to complete your booking.
  </strong>
</div>

<ng-container *ngIf="!feesUnavailable">
  <h2 class="govuk-heading-l">{{ 'COMMON.APPOINTMENT_FEES' | translate }}</h2>

  <table
    class="govuk-table govuk-table--small-text-until-tablet"
    *ngIf="dataStore.serviceFees"
  >
    <thead class="govuk-table__head">
      <tr class="govuk-table__row">
        <th scope="col" class="govuk-table__header">Items</th>
        <th scope="col" class="govuk-table__header">Quantity</th>
        <th scope="col" *ngIf="showBudgetCode" class="govuk-table__header">
          Budget Code
        </th>
        <th scope="col" class="govuk-table__header">Total</th>
        <ng-container *ngIf="daysAway > 182">
          <th scope="col" class="govuk-table__header">Deposit</th>
        </ng-container>
      </tr>
    </thead>
    <tbody class="govuk-table__body">
      <tr class="govuk-table__row" *ngFor="let fee of dataStore.serviceFees">
        <th scope="row" class="govuk-table__header">{{ fee.item }}</th>
        <td class="govuk-table__cell">{{ fee.quantity }}</td>
        <ng-container *ngIf="showBudgetCode">
            <td class="govuk-table__cell">{{ fee.budget_code }}</td>
          </ng-container>
        <td class="govuk-table__cell">
          {{ fee.cost * fee.quantity | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </td>
        <ng-container *ngIf="daysAway > 182">
          <td class="govuk-table__cell">
            {{
              fee.deposit * fee.quantity | currency : 'GBP' : 'symbol' : '1.2-2'
            }}
          </td>
        </ng-container>
      </tr>
      <tr class="govuk-table__row">
        <td class="govuk-table__header">Total</td>
        <td class="govuk-table__header">&nbsp;</td>
        <td *ngIf="showBudgetCode" class="govuk-table__header">&nbsp;</td>
        <td class="govuk-table__header">
          {{ costTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </td>
        <ng-container *ngIf="daysAway > 182">
          <td class="govuk-table__header">
            {{ depositTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
  <p class="govuk-body" *ngIf="!dataStore.serviceFees">Calculating fees</p>

  <div class="govuk-form-group">
    <fieldset class="govuk-fieldset">
      <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
        <h1 class="govuk-heading-l">
          {{ 'COMMON.PAYABLE_TODAY' | translate }}
        </h1>
      </legend>

      <div class="govuk-hint">
        In order to confirm your booking, we will need to take a payment of
        <b>{{ totalCost | currency : 'GBP' : true }}</b> today by credit or
        debit card. We are not able to hold bookings without payment and your
        booking will be cancelled if payment cannot be taken. Payment will be
        taken in the next step.
      </div>
    </fieldset>
  </div>
</ng-container>
